import { render, staticRenderFns } from "./StandardsMultiselect.vue?vue&type=template&id=85b0381a&scoped=true&"
import script from "./StandardsMultiselect.vue?vue&type=script&lang=js&"
export * from "./StandardsMultiselect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85b0381a",
  null
  
)

export default component.exports